import React from 'react';
import Card from '../../components/Card/card.js';
import './vieUniversitaire.css';

export default function VieUniversitaire() {
	const cartes = [
		{ image: "/images/culturelle.webp", title: "Activités Culturelles" },
  		{ image: "/images/sport.png", title: "Sports" },
  		{ image: "/images/amphi.png", title: "Vie Associative" },
  		{ image: "/images/livre.webp", title: "Bibliothèque" },
  		{ image: "/images/informatique.jpg", title: "Informatique" },
  		{ image: "/images/jardin.jpg", title: "Le Jardin Partagé" },
  		{ image: "/images/radio.jpg", title: "Radio Connectée" },
  		{ image: "/images/tp.jpg", title: "Les Ateliers Savoir-Faire" },
  		{ image: "/images/tp2.jpg", title: "Travaux Pratique" }
	];

	return (
		<section className="text-vieUniversitaire">
			<div className="container">
				<h1>Vie Universitaire</h1>
				<br />
				<p>
					Découvrez un environnement académique riche et dynamique qui favorise
					l'épanouissement personnel et professionnel de nos étudiants
				</p>
				<div className="culture-section">
					<h3>Pôle Culture</h3>
					<p>
						A l'IUSSE, la culture est un véritable enjeu de pédagogie, de savoir
						et d'expérience dans les parcours des étudiants. Elle nourrit les
						questionnements propres à la démarche scientifique, stimule l'esprit
						critique, l'engagement, l'imagination et la création.
					</p>
					<p>
						La culture artistique, la culture scientifique et la diffusion des
						savoirs sont au cœur des préoccupations du pôle culture.
					</p>
					<p>
						Proposer un espace de création, de recherche, de diffusion,
						d'expérimentation et de sensibilisation à la culture scientifique et
						artistique.
					</p>
				</div>
				<h2>Activités & Services</h2>
				<div className="carousel-wrapper">
					<div className="carousel-uni" >
						  {cartes.map((carte, index) => (
						    <Card
						      key={`original-${index}`}
						      image={carte.image}
						      title={carte.title}
						      width="350px"
						      height="280px"
						      imageHeight="220px"
						      clickable={false}
						    />
						  ))}
						  {cartes.map((carte, index) => (
						    <Card
						      key={`duplicate-${index}`}
						      image={carte.image}
						      title={carte.title}
						      width="350px"
						      height="280px"
						      imageHeight="220px"
						      clickable={false}
						    />
						  ))}
					</div>
				</div>
				<div className="services-section">
					<div className="service-item">
						<h4>🎨 Pôle Artistique</h4>
						<p>
							Ateliers de création, expositions, spectacles et événements
							culturels organisés tout au long de l'année.
						</p>
					</div>
					<div className="service-item">
						<h4>⚽ Activités Sportives</h4>
						<p>
							Large éventail d'activités sportives : sports collectifs, fitness,
							arts martiaux et bien-être.
						</p>
					</div>
					<div className="service-item">
						<h4>📚 Accompagnement Académique</h4>
						<p>
							Soutien scolaire, tutorat, orientation professionnelle et aide à
							l'insertion professionnelle.
						</p>
					</div>
				</div>
			</div>
		</section>
	);
}